import { render, staticRenderFns } from "./RelatorioPontoDiarioPage.vue?vue&type=template&id=adfe8096&scoped=true"
import script from "./RelatorioPontoDiarioPage.vue?vue&type=script&lang=js"
export * from "./RelatorioPontoDiarioPage.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPontoDiarioPage.vue?vue&type=style&index=0&id=adfe8096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfe8096",
  null
  
)

export default component.exports